import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AuthConfigurationService } from './auth-configuration.service';

// Runs when Amplify opens the authenticated slot so the app stays hidden until JWT tenant matches.
@Component({
  selector: 'app-verify-tenant-session',
  template: '',
})
export class VerifyTenantSessionComponent implements OnChanges {
  @Input() user: unknown;
  private started = false;

  constructor(private authConfigService: AuthConfigurationService) {}

  ngOnChanges(_changes: SimpleChanges): void {
    if (this.started || this.user == null) {
      return;
    }
    this.started = true;
    void this.authConfigService.allowAuthenticatedSessionIfTenantMatches(this.user);
  }
}
